import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * Legacy `/dashboard/*` → `/voxlane/*`, preserving the rest of the path.
 * Everything that lived under `/dashboard` belonged to Voxlane, so the
 * whole subtree maps across unchanged.
 */
export const Route = createFileRoute("/dashboard/$")({
  beforeLoad: ({ params }) => {
    const rest = params._splat ?? ""
    // `href` rather than `to`: built at runtime, so it isn't one of the
    // router's statically-known literal paths.
    throw redirect({ href: rest ? `/voxlane/${rest}` : "/voxlane", replace: true })
  },
})
